import { postReq, putReq } from '../infra/http';
import { getReq, createUrl } from "@/infra/http";
import { AdvanceShareStyleVersion, AdvanceShareStyleVersionPaginationFilterRequest, UpsertAdvanceShareStyleVersion } from '@/models/advance-share-style-version.model';
import { PagedResponseModel, BaseResponseModel, PaginatedSelectModel, PaginationFilterRequest } from "@/models/core.model";

export const getPagedAdvanceShareStyleVersions = async (input: AdvanceShareStyleVersionPaginationFilterRequest): Promise<PagedResponseModel<AdvanceShareStyleVersion>> => {
  return await getReq(createUrl("a/AdvanceShare/Style/Version/PagedData"),
    { params: input }
  ).then((res: any) => res.data);
};

export const getAdvanceShareStyleVersionsLookup = async (input?: string, styleId?: number, page?: number): Promise<PaginatedSelectModel> => {
  const model: AdvanceShareStyleVersionPaginationFilterRequest = {
    pageNumber: page ?? 1,
    pageSize: 100,
    keyword: input,
    isAscending: false,
    styleId: styleId
  };
  return await getPagedAdvanceShareStyleVersions(model).then(data => 
    ({ 
      data: data.result.map(itm => ({ 
        value: itm.id, 
        label: `${itm.style.name} (ver: ${itm.version ?? 'NAN'})`
      })),
      isLastPage: data.pageNumber >= data.totalPages,
    })      
  );
};

export const getAdvanceShareStyleVersion = async (id: number): Promise<BaseResponseModel<AdvanceShareStyleVersion>> => {
  return await getReq(createUrl(`a/AdvanceShare/Style/Version/GetById/${id}`),
  ).then((res: any) => res.data);
};

export const upsertAdvanceShareStyleVersion = async (input: UpsertAdvanceShareStyleVersion): Promise<BaseResponseModel<AdvanceShareStyleVersion>> => {
  return await postReq(createUrl("a/AdvanceShare/Style/Version/Upsert"),
    input
  ).then((res: any) => res.data);
};

export const publishAdvanceShareStyleVersion = async (id: number): Promise<BaseResponseModel<null>> => {
  return await putReq(createUrl("a/AdvanceShare/Style/Version/Publish/" + id),
  ).then((res: any) => res.data);
};
